import TagCloseIcon from "@/assets/svgs/tag-close-icon";
import { Text, View } from "react-native";
import { useSlot, useStyled } from "use-styled";

const TagRoot = useStyled(View, {
  base: {
    className: "items-center justify-center bg-teachLoop-creamDark",
    accessibilityRole: "button",
    style: {},
  },
  variants: {
    size: {
      sm: { className: "px-3 py-[1.5] rounded-[8]" },
      md: { className: "px-3 py-1 rounded-[11]" },
    },
    close: {
      true: { className: "gap-2 flex-row" },
    },
  },
  defaultVariants: {
    size: "sm",
  },
  compoundVariants: [],
});

const TagText = useStyled(Text, {
  base: {
    className: "font-geologica-regular font-normal text-teachLoop-textPrimary",
  },
  variants: {
    size: {
      sm: { className: "text-sm leading-[1.5]" },
      md: { className: "text-base leading-[1.5]" },
    },
  },
  defaultVariants: {
    size: "sm",
  },
});

const TagClose = useStyled(TagCloseIcon, {
  base: {
    className: "h-5 w-[10]",
    pathClassName: "fill-teachLoop-textPrimary opacity-50",
  },
  variants: {},
  defaultVariants: {},
});

export const Tag = useSlot(TagRoot, {
  Text: TagText,
  Close: TagClose,
});
